import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import packageData from '../../package.json';

const useCacheBuster = () => {
  const location = useLocation();
  const parseVersion = (str) => +str.replace(/\D/g, '');

  useEffect(() => {
    fetch(`/meta.json?v=${+new Date()}`, { cache: 'no-cache' })
      .then((response) => response.json())
      .then((meta) => {
        if (meta?.version) {
          const metaVersion = parseVersion(meta.version);
          const packageVersion = parseVersion(packageData.version);
          if (packageVersion < metaVersion) {
            if (window?.location?.reload) {
              alert(
                'Your version of website is outdated, click ok to reload the page',
              );
              window.location.reload();
            }
          } else {
          }
        } else {
        }
      })
      .catch((error) => {
        console.error('something went wrong fetching meta.json', error);
      });
  }, [location]);

  return null;
};

export default useCacheBuster;
